import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import { h1 } from '@helpers/typography';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  background: ${brand.beige};
  margin-bottom: var(--sectionSpacing);
`;
const Inner = styled.div `
  display: grid;
  gap: ${fluid(32, 40)};
  padding: ${fluid(24, 32)} 0 ${fluid(40, 85)};

  @media ${from(Device.Tablet)} {
    grid-template-columns: 1fr 1.5fr;
    align-items: center;
  }
`;
const Detail = styled.div ``;
const Title = styled.h1 `
  ${h1};
`;
const ImageWrapper = styled.div `
  ${imageWrapperPreserveRatio(3, 4)};

  @media ${from(Device.MobileLarge)} {
    ${imageWrapperPreserveRatio(16, 9)};
  }
`;
const Image = styled.img `
  ${imageCoverContainer()};
`;
const ArticleDetailPageHeroBannerStyles = {
    Container,
    Inner,
    Detail,
    Title,
    ImageWrapper,
    Image,
};
export default ArticleDetailPageHeroBannerStyles;
